import { render, staticRenderFns } from "./Stocks.vue?vue&type=template&id=7dbc64bc&scoped=true"
import script from "./Stocks.vue?vue&type=script&lang=js"
export * from "./Stocks.vue?vue&type=script&lang=js"
import style0 from "./Stocks.vue?vue&type=style&index=0&id=7dbc64bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbc64bc",
  null
  
)

export default component.exports